import { DataDogAddFeatureFlag } from "datadog-loader/loader";

type LogImpression = {
  impression: {
    feature: string;
    treatment: string;
  };
};

type CaptureFeatureFlag = ({
  flagName,
  treatment,
}: DataDogAddFeatureFlag) => void;

type ImpressionListener = {
  data: LogImpression;
  captureFeatureFlag: CaptureFeatureFlag;
};

export const impressions: string[] = [];

export const impressionListener = ({
  data,
  captureFeatureFlag,
}: ImpressionListener) => {
  const flagName = data.impression.feature;
  if (!impressions.includes(flagName)) {
    impressions.push(data.impression.feature);
    const treatment = data.impression.treatment;
    captureFeatureFlag({ flagName, treatment });
  }
};
